import React, { FC } from 'react'
import { useTypedSelector } from '../../hooks/useTypedSelector'
import { formatDataAge } from '../../models/maintenance'
import { EServices, TableHelper } from '../../types/tableHelper'
import styles from './css/MaintenanceBanner.module.css'

interface MaintenanceBannerProps {
	/** Сервисы, данные которых устарели (одна пара таблицы — до двух штук). */
	services: { service: EServices; updatedAt: number }[]
	onShowAnyway: () => void
}

/**
 * Плашка «сервис на технических работах» вместо строк таблицы.
 * Показывается, когда данные сервиса старше его порога (см. models/maintenance.ts).
 * Кнопка «Всё равно показать» отдаёт управление пользователю: данные не прячем
 * насовсем, подписчик вправе посмотреть последние известные цены.
 */
const MaintenanceBanner: FC<MaintenanceBannerProps> = ({ services, onShowAnyway }) => {
	const { lang: { Value: lang } } = useTypedSelector(x => x.lang)

	if (!services.length) return null

	return (
		<div className={styles.mtWrap}>
			<div className={styles.mtIcons}>
				{services.map(({ service }) => (
					<img
						key={service}
						className={styles.mtIcon}
						src={`Resources/ServicesIcons/${EServices[service].toLowerCase()}.png`}
						alt={TableHelper.GetServiceName(service)}
					/>
				))}
			</div>

			{services.map(({ service, updatedAt }) => (
				<div className={styles.mtTitle} key={service}>
					<b>{TableHelper.GetServiceName(service)}</b>{' '}
					{lang.TablePage_Maintenance_Title} {formatDataAge(updatedAt, lang)}
				</div>
			))}

			<div className={styles.mtSub}>{lang.TablePage_Maintenance_Sub}</div>

			<button className={styles.mtBtn} onClick={onShowAnyway}>
				{lang.TablePage_Maintenance_ShowAnyway}
			</button>
		</div>
	)
}

export default MaintenanceBanner
